import { z } from "zod";
export const QuoteLineSchema = z.object({
    label: z.string(),
    amountMinor: z.number(),
});
export const QuoteSchema = z.object({
    amountMinor: z.number(),
    currency: z.string(),
    lines: z.array(QuoteLineSchema),
});
// `accessGrant` here is the one-use booking_create child grant, distinct from
// the reusable public_catalog root grant used to create the intent.
export const BookingIntentSchema = z.object({
    intentId: z.string(),
    accessGrant: z.string(),
    expiresAt: z.string(),
    quote: QuoteSchema,
});
